import React, { ReactNode } from 'react'
import classNames from 'classnames'
import styles from './styles.scss'
import {THasClassName} from '@/types'

export const Title: React.FC<THasClassName & { children: ReactNode }> = ({ className, children }) => {
  return <span className={classNames(className, styles.root)}>{children}</span> 
}
